import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export const confirmationPhraseValidation = {
  mixins: [validationMixin],

  computed: {
    confirmationPhraseError () {
      let errors = ''
      const { localConfirmationPhrase } = this.$v
      if (localConfirmationPhrase.$dirty) {
        if (!localConfirmationPhrase.required) {
          errors = this.$t('validations.confirmation-phrase.required')
        }
      }
      return errors
    }
  },

  validations: {
    localConfirmationPhrase: {
      required
    }
  }

}
